/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderCalcTabCalculationSelectQueryVariables = {|
  classificationID: string
|};
export type PGAModelBuilderCalcTabCalculationSelectQueryResponse = {|
  +pgaModelCalculations: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>
|};
export type PGAModelBuilderCalcTabCalculationSelectQuery = {|
  variables: PGAModelBuilderCalcTabCalculationSelectQueryVariables,
  response: PGAModelBuilderCalcTabCalculationSelectQueryResponse,
|};
*/


/*
query PGAModelBuilderCalcTabCalculationSelectQuery(
  $classificationID: ID!
) {
  pgaModelCalculations(classificationId: $classificationID) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "classificationID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "classificationId",
        "variableName": "classificationID"
      }
    ],
    "concreteType": "PGATourModelCalculationType",
    "kind": "LinkedField",
    "name": "pgaModelCalculations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderCalcTabCalculationSelectQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderCalcTabCalculationSelectQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c047144f723cb452522c79faae371587",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderCalcTabCalculationSelectQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderCalcTabCalculationSelectQuery(\n  $classificationID: ID!\n) {\n  pgaModelCalculations(classificationId: $classificationID) {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1740aaab3d7a93756efdd94a4a6d34ff';

module.exports = node;
